import { Component, Input } from '@angular/core';
import { IconComponent } from '../labels/icon.component';
import { ToastComponent } from '../labels/toast.component';

@Component({
  selector: 'app-password-requirements',
  imports: [IconComponent, ToastComponent],
  template: `
    <div
      class="tw-rounded-lg tw-border tw-bg-[var(--sed-open-grey-color)]
      tw-text-sm tw-font-bold tw-text-[var(--sed-black-60-color)]
      tw-flex tw-flex-col tw-p-3"
    >
      <div
        class="tw-text-[13px] tw-text-[var(--sed-dynamic-black-color)] tw-pb-3"
      >
        Password requirements
      </div>
      @for (req of requirements; track req.label) {
        <div class="tw-flex tw-items-center tw-py-1.5">
          <div class="tw-grow-0 tw-pr-3 tw-w-[28px]">
            <div class="tw-w-[18px] tw-text-center">
              <app-icon name="fa-regular fa-circle" size="8px"></app-icon>
            </div>
          </div>
          <div class="tw-grow" [class.tw-pl-6]="req.child">{{ req.label }}</div>
        </div>
      }
      @if (error) {
        <div class="tw-flex tw-justify-center tw-pt-3">
          <app-toast type="Error">
            Error: Your password doesn't meet the required criteria.
          </app-toast>
        </div>
      }
    </div>
  `,
  styles: ``,
})
export class PasswordRequirementsComponent {
  @Input()
  error = false;

  requirements = [
    { label: 'Different than your username', child: false },
    { label: 'At least 8 characters', child: false },
    { label: 'Contain at least (3) of the following categories:', child: false },
    { label: 'Upper-case (A-Z)', child: true },
    { label: 'Lower-case (a-z)', child: true },
    { label: 'Numeric (0-9)', child: true },
    {
      label:
        'Non-alphanumeric / special character (For example: !,%,$,+,&,@,<, or #)',
      child: true,
    },
    {
      label:
        'New password cannot be the same as your current password or any of the previous 12 passwords',
      child: false,
    },
  ];
}
